export default __webpack_public_path__ + "files/cf5f44e3d3903bb4e4b42f1a53afb17a.mp3";